import { LocalStorageConstants } from "../constants/LocalStorageConstants.ts";
import QueryService from "../utils/QueryService.ts";

export type FeedbackReport = {
	positive: number;
	negative: number;
};

class FeedbackService {
	private feedback = new QueryService("/feedback/");

	private updateFeedbackCount(): void {
		if (!localStorage.getItem(LocalStorageConstants.FEEDBACK_COUNT)) {
			localStorage.setItem(LocalStorageConstants.FEEDBACK_COUNT, "1");
		} else {
			localStorage.setItem(
				LocalStorageConstants.FEEDBACK_COUNT,
				(Number(localStorage.getItem(LocalStorageConstants.FEEDBACK_COUNT)) + 1).toString(),
			);
		}
	}

	// Unified feedback method
	sendFeedback = async (feedbackData: any, isUpdate?: boolean): Promise<any> => {
		const response = await this.feedback.post("submit", feedbackData);
		if (!isUpdate) this.updateFeedbackCount();

		return response;
	};

	getFeedbackReport = async (modelId: string): Promise<FeedbackReport> => {
		const response = await this.feedback.get(`${modelId}/report`);
		return response.data;
	};
}

export default FeedbackService;
